import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { RECORDINGS } from '../../constants';
import { showModal, AAF_MODAL_ERROR, MODAL_PIN, HIDE_MODAL } from 'src/actions/modal';
import Translator from 'src/requests/apa/Translator';
import Utils from 'src/utils/Utils';
import { channelIsBlocked } from 'src/components/RibbonGridNew/utis';
import store from 'src/store';
class RibbonRecording extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.unFocusHandler = props.unFocusHandler;
        this.onClickHandler = props.onClickHandler ? props.onClickHandler : null;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.onFocus = this.onFocus.bind(this);
        this.ribbonIndex = props.index;
        this.api = props.api;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.isModalRecordSerie = props.code === "series";
    }

    onFocus(event) {
        if (typeof this.focusHandler === 'function') {
            this.focusHandler(event);
        }
    }

    validateChannelRecording = async (data) => {
        let isChannelRecordingBlocked = false;
        try {
            isChannelRecordingBlocked = await channelIsBlocked(data.group_id);
        } catch (err) {
            console.error('Error verificando canal bloqueado (validateChannelRecording)', err);
        }
        const parentalRatingMetadata=Utils.getRegionaliazedMetadata('sensitive_channel_ratings');
        const sensitiveChannelRatings = parentalRatingMetadata && parentalRatingMetadata[0] && Object.keys(parentalRatingMetadata[0]).length > 0 && parentalRatingMetadata[0].parental_rating;

        // Valida el 500 en el servicio: "/user/v2/controlpin/channels/check"
        if (isChannelRecordingBlocked === "SERVER_ERROR" && data.parentalRating === sensitiveChannelRatings) {
            // Lanzamos modal de Parental Rating si el servicio responde con un 500.
            const iconAlert = 'Alerta_IconoAlerta';
            const message = Translator.get('Homes_AlertaFalloDeValidacion_CanalBloqueado_TextoInformativo');
            const textButton = Translator.get('Homes_Aceptar_TextoBotonPrimario');
            const colorButton = Translator.get('Color_ColorPrimario');
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: {
                        code: "SERVER_ERROR",
                        icon: iconAlert,
                        message: message,
                        textButton: textButton,
                        colorButton: colorButton,
                        withBack: false,
                        errorFrom: 'parental-rating-mis_grabaciones'
                    },
                    asset: iconAlert,
                    callback: () => { },
                }
            };
            store.dispatch(showModal(modal));
            return { shouldContinue: false };
        } else if (isChannelRecordingBlocked) {
            const closeModal = () => {
                store.dispatch(
                    showModal({
                        modalType: HIDE_MODAL,
                        modalProps: {},
                    })
                );
            };
 
            const modal = {
                modalType: MODAL_PIN,
                modalProps: {
                    successCallBack: () => {
                        // Al ser correcto el PIN, el contenido se puede reproducir
                        this.onClickHandler && this.onClickHandler(data, !isChannelRecordingBlocked)
                     },
                    failedCallBack: () => { },
                    handleClose: () => {}
                }
            };
            store.dispatch(showModal(modal));
            return false;
        } else {
            return { shouldContinue: true, isChannelRecordingBlocked };
        }
    }

    async clickHandler(data) {
        const { shouldContinue, isChannelRecordingBlocked } = await this.validateChannelRecording(data);

        if (!shouldContinue) {
            return;
        } else {
            console.log("clickHandler RibbonRecordings");
            this.onClickHandler && this.onClickHandler(data, isChannelRecordingBlocked);
        }
    }

    getEventId(event) {
        return event.event_alf_id || event.event_id
    }

    render() {
        return (
            <div className="ribbon-items ribbon-recordings">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;

                    const canalesBloqueados = store.getState().pinCodes.pin_channel.info;
                    const isChannelRecordingBlocked = canalesBloqueados && canalesBloqueados.includes(node_item.group_id.toString());

                    const key = Math.random() * 10;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    const [
                        {item: firstItem} = {},
                        {item: secondItem} = {}
                    ] = this.visibleItems;

                    return (
                        <Card
                            cover={node_item.cover}
                            unFocusHandler={this.unFocusHandler}
                            focusHandler={this.focusHandler}
                            id={ this.isModalRecordSerie ? this.getEventId(node_item) : index + 1}
                            ribbonId= {this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id}
                            typeRender={this.typeRender}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                e.preventDefault();
                                e.stopPropagation();
                                this.clickHandler(node_item);
                            }}
                            hideTitles={this.props.hideTitles}
                            isRecentActivity={this.props.isRecentActivity}
                            label={node_item.label}
                            type={RECORDINGS}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={this.isModalRecordSerie && secondItem
                                ? `#link-${this.getEventId(secondItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={this.isModalRecordSerie && firstItem
                                ? `#link-${this.getEventId(firstItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            setMetricsEvent={this.setMetricsEvent}
                            sibling={node_item.sibling}
                            hideInnerTitle={this.hideInnerTitle}
                            keyDownHandler={this.keyDownHandler}
                            is_music={false}
                            api={this.api}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                            isChannelRecordingBlocked={isChannelRecordingBlocked}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonRecording;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonRecordings/index.jsx